import axios from 'axios';
import { ExplorerEntityMeta, ExplorerEntityShortMeta } from 'entities/types';

export const staticFilesBaseUrl = process.env.REACT_APP_STATIC_FILES_BASE_URL;
export const downloadBaseUrl = process.env.REACT_APP_DOWNLOAD_BASE_URL;
export const baseURL =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
    ? process.env.REACT_APP_DEV_API_BASE_URL
    : process.env.REACT_APP_PROD_API_BASE_URL;

export const SSO_URL = `${baseURL}/auth/oauth2/ic-pass`;

export const axiosApi = axios.create();
axiosApi.defaults.baseURL = baseURL;
axiosApi.defaults.headers.common['Authorization'] = `Bearer`;

export const setToken = (token: string) => {
  axiosApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const getAbsPath = (rel?: string | null) => {
  if (!rel) {
    return rel;
  }
  return `${staticFilesBaseUrl}${rel}`;
};

export const downloadFile = async ({
  id,
  name,
}: {
  id: string;
  name: string;
}) => {
  const link = document.createElement('a');
  link.href = `${downloadBaseUrl}/${id}`;
  link.download = name;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getPath = async (entity: ExplorerEntityShortMeta) => {
  const res = await axiosApi.get<{ breadcrumb: ExplorerEntityMeta[] }>(
    '/breadcrumb',
    {
      params: { entity_id: entity.id, entity_type: entity.type },
    }
  );

  return res.data.breadcrumb;
};
